module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x640-516f56c92aeef4176fb1ec3b2815514b.webp";